import { REGISTER_USER } from "../../actionTypes/actionsTypes";
import { AppAction, BaseAsyncReducerState } from "../../types";

export interface RegisterUserResponse extends BaseAsyncReducerState{
    success: boolean;
    userprofileid?: string;
    response: Record<string, unknown>; 
}   

// Define an initial state value for the app
const initialState: RegisterUserResponse = {
    loading: false,
    error: false,
    success: false,
    response: {}
}

function registerUserResponseReducer(state = initialState, action: AppAction): RegisterUserResponse | Record<string, unknown> {

    const { payload } = action;

    switch (action.type) {
        case REGISTER_USER.PENDING:
            return {
                ...state,
                loading: true,
                error: false,
            }
        case REGISTER_USER.SUCCESS:

            return {
                ...state,
                ...payload,
                response: {...payload},
                loading: false,
                error: false,
            }

        case REGISTER_USER.ERROR:
            return {
                ...state,
                loading: false,
                error: payload
            };

        default:
            // If the reducer doesn't care about this action type,
            // return the existing state unchanged
            return state
    }
}

export default registerUserResponseReducer;